import { NgModule } from '@angular/core';
import { ChipListInputComponent } from './chip-list-input.component';
import { MatChipsModule } from '@angular/material/chips';
import { FlexModule } from '@ngbracket/ngx-layout';
import { AsyncPipe, JsonPipe, NgForOf, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslationModule } from '@core/translation/translation.module';

@NgModule({
    declarations: [ChipListInputComponent],
    exports: [ChipListInputComponent],
    imports: [
        MatChipsModule,
        FlexModule,
        NgForOf,
        MatIconModule,
        MatInputModule,
        NgIf,
        AsyncPipe,
        MatAutocompleteModule,
        MatOptionModule,
        ReactiveFormsModule,
        MatButtonModule,
        JsonPipe,
        MatTooltipModule,
        TranslationModule,
    ]
})
export class ChipListInputModule {
}
